export const BLOCK_STYLE_TYPE = "blockquote";

export const allowedBlockTypes = [BLOCK_STYLE_TYPE];
